import { render, staticRenderFns } from "./AboutShoppingList.vue?vue&type=template&id=6888825f&"
import script from "./AboutShoppingList.vue?vue&type=script&lang=js&"
export * from "./AboutShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./AboutShoppingList.vue?vue&type=style&index=0&id=6888825f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports